export default "<input type=\"file\"  (change)=\"uploadFile($event)\"/>\n"